import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { PATH_AFTER_LOGOUT } from 'src/config-global';

import { useAuthStore } from '../store/auth.store';

export const useLogout = () => {
  const { logout } = useAuthStore();
  const navigate = useNavigate();

  const handleLogout = useCallback(() => {
    logout();
    navigate(PATH_AFTER_LOGOUT, { replace: true });
  }, [logout, navigate]);

  return {
    logout: handleLogout,
  };
};
